module.exports = __webpack_public_path__ + "img/Magnifying_glass_icon.d4c1f726.png";